import axios from 'axios';

export function registeredAgentAccount(account) {
    const bankCd = account?.bank_cd;
    const bankName = account?.bank_nm || account?.bank_name;
    const number = account?.accnt_no || account?.account_number;
    if (!bankCd || !bankName || !number) return null;
    return { bankCd, bankName, account: number, accountName: account.accnt_nm || account.accnt_holder || account.account_holder };
}

export async function lookupAgentAccountHolder(recipient) {
    try {
        const response = await axios.post(process.env.REACT_APP_API + '/api/agent-wallet/account-holder', {
            bank_cd: recipient.bankCd, accnt_no: recipient.account,
        }, { withCredentials: true });
        return response.data;
    } catch (error) {
        return error.response?.data ?? { msg: '예금주 조회에 실패했습니다. 다시 조회해주세요.' };
    }
}

export async function transferAgentWallet(body) {
    try {
        const response = await axios.post(process.env.REACT_APP_API + '/api/agent-wallet/withdraw', body, { withCredentials: true });
        const result = response.data;
        return { ok: result?.code === 1000, code: result?.code, msg: result?.msg };
    } catch (error) {
        return { ok: false, code: error.response?.data?.code, msg: error.response?.data?.msg ?? '송금 처리 결과를 확인하지 못했습니다. 같은 요청의 결과를 다시 확인해주세요.' };
    }
}
